export enum SessionStatuses {
  BOOKING = 'BOOKING',
  REQUESTING_SERVICE = 'REQUESTING_SERVICE',
  SERVICE_IN_PROGRESS = 'SERVICE_IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  SUPPORT = 'SUPPORT',
}
